import TeamStatistics from "../components/TeamStatistics";

//type '0' only a label, no stats
//type '1' stat from code
//type '2' stat from extendedStatItemns
//type '3' stat 'value1 / value2'

function WpoTeamStats({ data }) {
  const statsConfig = [
    {index: 'a', type: '0', label: 'LabelPossessesion'},
    {index: 'b', type: '1', label: 'LabelNumberPossessions',       code: 'POSSESS', data:'VALUE'},
    {index: 'c', type: '2', label: 'LabelTime',                    code: 'POSSESS', extendedCode: 'TIME', extendedData:'VALUE'},
    {index: 'd', type: '1', label: 'HeaderPercentageDesc',         code: 'POSSESS', data: 'ATTEMPT'},
    {index: 'e', type: '0', label: 'HeaderG/SDesc'},
    {index: 'f', type: '3', label: 'LabelAllActionShots',          code: 'ACT',     data: 'VALUE', data2: 'ATTEMPT'}, 
    {index: 'g', type: '3', label: 'LabeExtraPlayerShot',          code: 'EXT',     data: 'VALUE', data2: 'ATTEMPT'}, 
    {index: 'h', type: '3', label: 'LabelPenaltyshot',             code: 'PTY',     data: 'VALUE', data2: 'ATTEMPT'}, 
    {index: 'i', type: '0', label: 'LabelExtraPlayerEfficiency'},    
    {index: 'j', type: '1', label: 'HeaderGoals',                  code: 'EXT_TEAM', data:'VALUE'},
    {index: 'k', type: '2', label: 'LabelExtraPlayerSituation',    code: 'EXT_TEAM', extendedCode: 'SIT', extendedData:'VALUE'},
    {index: 'l', type: '1', label: 'LabelEfficiency%',             code: 'EXT_TEAM', data:'PERCENT'},
    {index: 'm', type: '0', label: 'LabelExclusion'},
    {index: 'n', type: '1', label: 'LabelWithSubstitution',        code: 'EXC_WS',   data: 'VALUE'},    
    {index: 'o', type: '1', label: 'LabelWithSubstitutionAfter4m', code: 'EXC_WT',   data: 'VALUE'}    
  ]


  
  return (<>
    <TeamStatistics data={data?.results} statsConfig={statsConfig} order='1'/>
    <TeamStatistics data={data?.results} statsConfig={statsConfig} order='2'/>
  </>);
}

export default WpoTeamStats;